<template lang="html">
  <section class="subview-container column">
    <div class="profile-container">
      <div class="header-part row">
        <div class="ctn-profile-light row">
          <!-- <div class="ctn-profile-pic">
            <img id="userPicture" :src="userM.picture" alt="">
          </div> -->
          <div class="ctn-label">
            <div class="ctn-name">
              {{ user.firstname }} {{ user.lastname }}
            </div>
            <!-- <div class="link" @click="procNewPicture">
              Éditer la photo
              <input id="newPicture" type="file" v-on:change="uploadNewPicture">
            </div> -->
          </div>
        </div>
        <div class="ctn-logout">
          <div class="btn btn-red" @click="logout">
            Déconnexion
          </div>
        </div>
      </div>
      <div class="body-part row">
        <div class="half edit-profile">
          <form class="default-form-ui" novalidate>
            <div class="title">
              Informations générales
            </div>
            <div class="form-elem-container">
              <div class="ctn-input ctn-label" :class="{error: errors.has('email')}">
                <input type="email" v-validate="'required|email'" name="email" v-model="userM.email" placeholder="Email">
              </div>
              <div v-if="errors.has('email')" class="error-message">{{ errors.first('email') }}</div>
            </div>
            <div class="form-elem-container">
              <div class="ctn-input ctn-label" :class="{error: errors.has('prénom')}">
                <input type="text" v-validate="'required|alpha_dash_spaces'" name="prénom" v-model="userM.firstname" placeholder="Prénom">
              </div>
              <div v-if="errors.has('prénom')" class="error-message">{{ errors.first('prénom') }}</div>
            </div>
            <div class="form-elem-container">
              <div class="ctn-input ctn-label" :class="{error: errors.has('nom')}">
                <input type="text" v-validate="'required|alpha_dash_spaces'" name="nom" v-model="userM.lastname" placeholder="Nom">
              </div>
              <div v-if="errors.has('nom')" class="error-message">{{ errors.first('nom') }}</div>
            </div>
            <!-- <div class="form-elem-container">
              <div class="ctn-input ctn-label" :class="{error: errors.has('adresse')}">
                <input type="text" v-validate="'required'" name="adresse" v-model="userM.address.line" placeholder="Adresse">
              </div>
              <div v-if="errors.has('adresse')" class="error-message">{{ errors.first('adresse') }}</div>
            </div>
            <div class="form-elem-container">
              <div class="ctn-input ctn-label" :class="{error: errors.has('code postal')}">
                <input type="text" v-validate="'required|numeric|length:5'" name="code postal" v-model="userM.address.zip" placeholder="Code postal">
              </div>
              <div v-if="errors.has('code postal')" class="error-message">{{ errors.first('code postal') }}</div>
            </div>
            <div class="form-elem-container">
              <div class="ctn-input ctn-label" :class="{error: errors.has('ville')}">
                <input type="text" v-validate="'required|alpha'" name="ville" v-model="userM.address.city" placeholder="Ville">
              </div>
              <div v-if="errors.has('ville')" class="error-message">{{ errors.first('ville') }}</div>
            </div>
            <div class="form-elem-container">
              <div class="ctn-input ctn-label" :class="{error: errors.has('pays')}">
                <input type="text" v-validate="'required|alpha'" name="pays" v-model="userM.address.country" placeholder="Pays">
              </div>
              <div v-if="errors.has('pays')" class="error-message">{{ errors.first('pays') }}</div>
            </div>
            <div class="form-elem-container">
              <div class="ctn-input ctn-label" :class="{error: errors.has('téléphone')}">
                <input type="text" v-validate="'required|numeric|length:10'" name="téléphone" v-model="userM.phone" placeholder="Téléphone">
              </div>
              <div v-if="errors.has('téléphone')" class="error-message">{{ errors.first('téléphone') }}</div>
            </div> -->
          </form>
        </div>
        <div class="half edit-password column">
          <form class="form-ui default-form-ui" novalidate>
            <div class="item">
              <div class="title">
                Mot de passe
              </div>
              <div class="link" @click="displayChangePassword = true">
                Éditer le mot de passe
              </div>
            </div>
          </form>
          <div class="btn btn-red save" @click="saveProfile">
            Sauvegarder
          </div>
        </div>
      </div>
    </div>
    <base-modal :show="displayChangePassword" @close="displayChangePassword = false" :content="contentModalPassword" />
  </section>
</template>

<script>
  import RadioBox from '@/common/components/Form/RadioBox'
  import ModalChangePassword from '@/components/modal/ChangePassword'
  import { mapGetters } from 'vuex'
	import { Validator } from 'vee-validate'

	Validator.extend('alpha_dash_spaces', {
		getMessage: field => 'Le champ ' + field + ' ne peut contenir que des caractères des tirets et des espaces',
		validate: value => {
			for (let i = 0; i < value.length; i++) {
				if ('aàbcçdeéèfghijklmnopqrstuvwxyz -'.indexOf(value[i].toLowerCase()) === -1) { return false }
			}
			return true
		}
	})

  export default {
    name: 'Profile',
    components: {
      RadioBox
    },
    data () {
      return {
        userM: {
          email: null,
          firstname: null,
          lastname: null,
          address: {
            line: null,
            zip: null,
            city: null,
            country: null
          },
          phone: null,
          picture: null,
          password: null
        },
        isAvailable: false,
        displayChangePassword: false,
        contentModalPassword: ModalChangePassword,
        mailNotif: false,
        acceptCGU: false,
        acceptDER: false,
        error: {
          cgu: false,
          der: false
        }
      }
    },
    mounted () {
      this.userM = {
        email: this.user.email,
        firstname: this.user.firstname,
        lastname: this.user.lastname,
        address: {
          line: this.user.address.line,
          zip: this.user.address.zip,
          city: this.user.address.city,
          country: this.user.address.country
        },
        phone: this.user.phone,
        picture: this.user.picture,
        password: null,
        newPassword1: null,
        newPassword2: null
      }
    },
    computed: {
      ...mapGetters({
        user: 'user'
      })
    },
    methods: {
      uploadNewPicture (value) {
        const preview = document.getElementById('userPicture')
        const file = value.path[0].files[0]
        const reader = new FileReader()

        reader.addEventListener('load', () => {
          preview.src = reader.result
          this.$store.dispatch('updateProfilePicture', reader.result)
        })

        if (file) {
          reader.readAsDataURL(file)
        }
      },
      procNewPicture () {
        document.getElementById('newPicture').click()
      },
      saveProfile () {
        this.$validator.validate().then((result) => {
          if (result) {
            this.$store.dispatch('saveProfile', this.userM).then(() => {
              this.$notify({
                type: 'success',
                group: 'default',
                title: 'Félicitations',
                text: 'Les modifications ont été apporté à votre profile'
              })
            }).catch((error) => {
              let message = ''
              if (Object.keys(error.response.data.errors).indexOf('email') !== -1) message = 'Cette adresse email est déjà utilisé'
              this.$notify({
                type: 'error',
                group: 'default',
                title: 'Une erreur est survenue',
                text: message
              })
            })
          }
        })
      },
      setAvailable (val) {
        this.isAvailable = val
        this.showUnavailable = !val
      },
      logout () {
        this.$store.dispatch('logout').finally(() => {
          this.$router.push({ name: 'Login' })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Profile.vue?44f4447d